import React from 'react';
import { useParams } from 'react-router-dom';
import { Button, Dropdown, HeadContent, ToolbarButton, useCopyToClipboard, useMediaQueryContext, } from '@fourthwall/components';
import { DotsHorizontalIcon } from '@fourthwall/icons';
import { reverse, routing } from '@utils/routing';
import { ProductStatusTagDropdownContainer } from '../Dashboard/Product/ProductStatusTagDropdown';
import { useOrderSamples } from '../Dashboard/Product/SingleProduct/hooks/useOrderSamples';
import { useOffer } from '../Dashboard/Product/hooks/useOffer';
import { useCurrentShopQuery } from '../Dashboard/hooks/useCurrentShopQuery';
import { IframePreview } from './components/IframePreview';
import { useOfferPreviewTracking } from './modules/useOfferPreviewTracking';
export const OfferPreview = () => {
    const { productId = '' } = useParams();
    const { currentShopQuery } = useCurrentShopQuery(undefined, { staleTime: Infinity });
    const { offer, isSuccess: isOfferSuccess } = useOffer(productId);
    const { onOrderSamples } = useOrderSamples(productId);
    useOfferPreviewTracking({ offerId: productId, productId: offer?.productId });
    const media = useMediaQueryContext();
    const { copyToClipboard } = useCopyToClipboard({
        toastMessage: 'Product URL copied',
    });
    if (!currentShopQuery.isSuccess || !isOfferSuccess)
        return null;
    const getUrl = (path) => {
        const src = new URL(currentShopQuery.data?.internalBaseUri);
        src.pathname = path; // TODO: Create shop renderer utils.
        return src.toString();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(HeadContent, { title: offer.name }),
        React.createElement(IframePreview, { headline: "Congratulations! Your product is", status: React.createElement(ProductStatusTagDropdownContainer, { size: "medium" }), buttons: [
                React.createElement(Button, { label: "Order samples", appearance: "primary", size: "small", disabled: !onOrderSamples, onClick: onOrderSamples }),
                React.createElement(Button, { label: "Create another", href: routing.productCatalog.self, size: "small" }),
            ], dropdown: React.createElement(Dropdown, { content: React.createElement(React.Fragment, null,
                    React.createElement(Dropdown.Item, { label: "Copy URL", onClick: () => copyToClipboard(getUrl(`/products/${offer.slug}`)) }),
                    React.createElement(Dropdown.Item, { label: "Edit product", to: reverse(routing.products.all.product.self, { productId }) }),
                    React.createElement(Dropdown.Item, { label: "Back to dashboard", to: routing.home })) },
                React.createElement(ToolbarButton, { icon: DotsHorizontalIcon, size: media.tablet ? 'medium' : 'extraSmall', variant: "secondary" })), iframeSrc: getUrl(`/theme_editor/products/${offer.slug}`) })));
};
